module.exports = __webpack_public_path__ + "img/collection-weddingRingsBlack@2x.c823bde.webp";